import { Info, EuroSymbol, AccountTree } from "@mui/icons-material";

export const tabs = [
	{
		icon: <Info />,
		entity: "detail",
		label: "Detalhes",
	},
	{
		icon: <EuroSymbol />,
		entity: "orders",
		label: "Compras",
	},
	{
		icon: <AccountTree />,
		entity: "operational_centers",
		label: "Centros Operacionais",
	},
];
